<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-bind="attrs"
            v-on="on"
            :label="label"
            v-model="model"
            required
            outlined
            @click="onClick"
            @keyup="onKeyup"
            @change="onChange"
            hide-details
            :loading="loading"
        ></v-text-field>
      </template>

      <v-list v-if="items.length > 0">
        <v-list-item-group v-model="itemSelected">
          <v-list-item
              @click="() => onClickItem(item)"
              v-for="(item, index) in items"
              :key="index"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'AutoComplete',
  props: {
    label: String,
    value: String,
    callback: {
      required: true,
      type: Function
    }
  },
  mounted() {
    this.model = this.value
  },
  watch: {
    value(value) {
      this.model = value
    }
  },
  data: () => ({
    itemSelected: null,
    model: '',
    items: [],
    loading: false,
    timeoutId: null
  }),
  methods: {
    onClick() {
      const textSearch = this.model
      this.search(textSearch)
    },
    onKeyup(event) {
      const textSearch = event.target.value
      this.search(textSearch)
    },
    onChange(value) {
      this.$emit('change', value)
    },
    onClickItem(item) {
      this.model = item.value
      this.$emit('click', item)
      this.$emit('change', item.value)
    },
    search(textSearch) {
      if (!textSearch || textSearch.length < 3) {
        return
      }

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        this.loading = true
        this.items = await this.callback(textSearch)
        this.loading = false
      }, 400)
    }
  }
}
</script>

<style scoped>

</style>